import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { LoadingIndicator } from 'components';
import { useAuthenticator } from '@aws-amplify/ui-react';
import SplashScreen from 'components/Splash/Splash';
// import { Layout } from 'pages/AppManagement/containers';

export const PrivateRoute = ({ component: Component, path }: any): any => {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);

  // const role = "ADMIN";

  if (authStatus === 'configuring') return <SplashScreen />;
  return (
    <Route
      path={path}
      render={(props: any): any => {
        if (authStatus === 'unauthenticated') {
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
        }
        // if (rest.allowedRoles.indexOf(role) === -1) {
        //   return <Redirect to={{ pathname: '/courses', state: { from: props.location } }} />;
        // }
        return (
          // <Layout {...layoutProps} title={rest.title} redirectPath={rest.redirect} topBarMenu={rest.topBarMenu}>
          <Suspense fallback={<LoadingIndicator visible />}>
            <Component />
          </Suspense>
          // </Layout>
        );
      }}
    />
  );
};
